import { getSearchSessionPrefix, searchSessionKey } from "./searchSessionStorage";

const CACHE_NAME = "savedPage_v1";

const memoryByPrefix = new Map();

function rememberInMemory(prefix, payload) {
  memoryByPrefix.set(prefix, payload);
}

export function readSavedPageCache() {
  const prefix = getSearchSessionPrefix();
  const mem = memoryByPrefix.get(prefix);
  if (mem && typeof mem === "object") return mem;

  try {
    const raw = sessionStorage.getItem(searchSessionKey(CACHE_NAME));
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function reviveSavedProfessors(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map((p) => ({
    ...p,
    saved_date: p.saved_date != null ? new Date(p.saved_date) : p.saved_date,
  }));
}

function reviveSeenProfessors(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map((p) => ({
    ...p,
    seen_date: p.seen_date != null ? new Date(p.seen_date) : p.seen_date,
  }));
}

/**
 * Initial snapshot for Saved page (signed-in only). Restores cards on first paint
 * when toggling routes in the same session.
 */
export function getAuthSavedPageCacheSnapshot() {
  if (typeof window === "undefined" || !localStorage.getItem("authToken")) {
    return null;
  }
  const cached = readSavedPageCache();
  if (!cached || typeof cached !== "object") return null;

  return {
    savedProfessors: reviveSavedProfessors(cached.savedProfessors),
    allProfessorsSeen: reviveSeenProfessors(cached.allProfessorsSeen),
    schoolsOfSavedProfessors: Array.isArray(cached.schoolsOfSavedProfessors)
      ? cached.schoolsOfSavedProfessors
      : [],
  };
}

export function writeSavedPageCache(payload) {
  const prefix = getSearchSessionPrefix();
  rememberInMemory(prefix, payload);
  try {
    sessionStorage.setItem(
      searchSessionKey(CACHE_NAME),
      JSON.stringify(payload)
    );
  } catch (e) {
    console.warn("saved page cache write failed", e);
  }
}

export function clearSavedPageCache() {
  try {
    memoryByPrefix.clear();
    sessionStorage.removeItem(searchSessionKey(CACHE_NAME));
  } catch {
    /* ignore */
  }
}
